import {
  createContext,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../api/api";

interface iUserProvider {
  children: React.ReactNode;
}

// interface iUser {
// 	id: number;
// 	name: string;
// 	username: string;
// 	icon: string;
// 	image: string;
// 	bio: string;
// 	email: string;
// 	password: string;
// }

interface iImages {
  id: number;
  publicId: string;
  url: string;
  secureUrl: string;
  createdAt: Date;
}

interface iUserImage {
  id: number;
  name: string;
  username: string;
  bio: string;
  icon: string;
  role: "user" | "admin";
  image: string;
  phone: string;
  email: string;
  isTermAccepted: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
}

interface iFollow {
  count: number;
  raw: iUserImage[];
}

export interface iUserFollower extends iUserImage {
  Followers: iFollow;
  Following: iFollow;
}

// interface iPost {
// 	id: number;
// 	message: string;
// 	like: number;
// 	dislike: number;
// 	createdAt: Date;
// 	Images: iImages[];
// 	User: iUserImage;
// }
interface iFormLoginData {
  email: string;
  password: string;
}

interface iFormRegisterData {
  name: string;
  username: string;
  email: string;
  password: string;
}

interface iUserUpdate {
  name?: string;
  username?: string;
  bio?: string | null | undefined;
  icon?: string;
  role?: "user" | "admin";
  image?: string | null | undefined;
  phone?: string;
  email?: string;
  password?: string;
}

interface iForgotSenhaEmail {
  email: string;
}

interface iResetSenha {
  token: string;
  password: string;
}

interface iUserContext {
  user: iUserFollower | null;
  // posts: iPost[] | [];
  // filteredArray: any[];
  // filterSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  userLogin: (
    formData: iFormLoginData,
    setShowLogin: Dispatch<SetStateAction<boolean>>
  ) => void;
  userRegister: (
    formData: iFormRegisterData,
    setShowRegister: Dispatch<SetStateAction<boolean>>
  ) => void;
  userLogout: () => void;
  loading: boolean;
  editPerfil: (data: iUserUpdate) => void;
  followUser: (id: number) => void;
  unfollowUser: (id: number) => void;
  loadFollowers: (userId: number) => void;
  loadFollowing: (userId: number) => void;
  followers: iFollow | null;
  following: iFollow | null;
  forgotSenha: (data: iForgotSenhaEmail) => void;
  resetSenha: (data: iResetSenha) => void;
  checkIfUserFollow: (payload: {
    followerId: number;
    userId: number;
  }) => Promise<any>;
  // setLoading: React.Dispatch<SetStateAction<boolean>>;
  isTermAccepted: boolean;
  setIsTermAccepted: Dispatch<SetStateAction<boolean>>;
  updateUserTerm: (isTerm: boolean) => void
}

export const UserContext = createContext({} as iUserContext);

export const UserProvider = ({ children }: iUserProvider) => {
  const [user, setUser] = useState<iUserFollower | null>(null);
  const [followers, setFollowers] = useState<iFollow | null>(null);
  const [following, setFollowing] = useState<iFollow | null>(null);

  const [loading, setLoading] = useState(true);

  const [isTermAccepted, setIsTermAccepted] = useState(true)

  const navigate = useNavigate();

  useEffect(() => {
    const loadUser = async () => {
      const storedUserId = localStorage.getItem("@USER_ID");
      const token = localStorage.getItem("@TOKEN"),
        userId = storedUserId || null;

      if (!token) {
        setLoading(false);
        return;
      }

      try {
        api.defaults.headers.common.authorization = `Bearer ${token}`;
        if (userId) {
          retrieveUser(userId);
          loadFollowers(Number(userId));
          loadFollowing(Number(userId));
        }
      } catch (error) {
        console.log(error);
        // localStorage.clear();
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [navigate]);

  const retrieveUser = async (id: string) => {
    try {
      const response = await api.get(`/users/id/${id}`);
      const userData = response.data;

      if (!userData.isTermAccepted) {
        console.log("não ceitoyu")
        setIsTermAccepted(false)
      }

      setUser(userData);
    } catch (error) {
      console.log(error);
    }
  };

  const userLogin = async (
    data: iFormLoginData,
    setShowLogin: Dispatch<SetStateAction<boolean>>
  ) => {
    try {
      const response = await api.post("login", data);
      const { accessToken, User: userData } = await response.data;

      if (!userData.isTermAccepted) {
        console.log("não ceitoyu")
        setIsTermAccepted(false)
      }

      localStorage.setItem("@TOKEN", accessToken);
      localStorage.setItem("@USER_ID", userData.id);

      setUser(userData);

      api.defaults.headers.common.authorization = `Bearer ${accessToken}`;
    } catch (error) {
      console.log(error);
    } finally {
      setShowLogin(false);
    }
  };

  const userRegister = async (
    data: iFormRegisterData,
    setShowRegister: Dispatch<SetStateAction<boolean>>
  ) => {
    try {
      const response = await api.post("users", data);

      userLogin(data, setShowRegister);

    } catch (error) {
      console.log(error);
    } finally {
      setShowRegister(false);
    }
  };

  const userLogout = () => {
    localStorage.clear();

    setUser(null);
    navigate("/ultimas");
  };

  const editPerfil = async (data: iUserUpdate): Promise<void> => {
    try {
      const token = localStorage.getItem("@TOKEN");

      api.defaults.headers.common.authorization = `Bearer ${token}`;

      await api.patch(`users/${user?.id}`, data);
    } catch (error) {
      console.log(error);
    } finally {
      console.log(data);
      if (data.username) {
        navigate(`/perfil/${data.username}`);
      }
    }
  };

  const loadFollowers = async (userId: number) => {
    try {
      const response = await api.get(`users/followers/${userId}`);

      setFollowers(response.data);
    } catch (error) {
      console.error("Erro ao carregar seguidores e seguidos:", error);
    }
  };

  const loadFollowing = async (userId: number) => {
    try {
      const response = await api.get(`users/following/${userId}`);

      setFollowing(response.data);
    } catch (error) {
      console.log("Erro ao carregar seguidores e seguidos:", error);
    }
  };

  const checkIfUserFollow = async (payload: {
    followerId: number;
    userId: number;
  }) => {
    try {
      const response = await api.get(`/users/check/isfollow`, {
        params: payload,
      });

      return response.data;
    } catch (error) {
      console.error(error);
    }
    // finally {
    // 	loadFollowersAndFollowing(id);
    // }
  };
  const followUser = async (id: number) => {
    try {
      await api.post(`/users/follow/${id}`);
    } catch (error) {
      console.error("Erro ao seguir:", error);
    } finally {
      loadFollowing(id);
      loadFollowers(id);
    }
  };

  const unfollowUser = async (id: number) => {
    try {
      await api.delete(`users/follow/${id}`);
    } catch (error) {
      console.error("Erro ao deixar de seguir:", error);
    } finally {
      loadFollowing(id);
      loadFollowers(id);
    }
  };

  const forgotSenha = async (data: iForgotSenhaEmail): Promise<void> => {
    try {
      await api.post(`users/request-reset-password`, data);
    } catch (error) {
      console.error("Erro ao :", error);
    }
  };

  const resetSenha = async (data: iResetSenha): Promise<void> => {
    const payload = { password: data.password };
    try {
      await api.post(`users/reset-password/${data.token}`, payload);
    } catch (error) {
      console.error("Erro ao resetar a senha:", error);
    }
  };

  const updateUserTerm = async (isTerm: boolean): Promise<void> => {
    try {
      const response = await api.patch(`users/${user!.id}`, { isTermAccepted: isTerm })

      console.log(response.data)
    } catch (error) {
      console.error("Erro ao aceitar termo:", error)
    }

  }


  return (
    <UserContext.Provider
      value={{
        user,
        userLogin,
        userRegister,
        userLogout,
        loading,
        editPerfil,
        followUser,
        unfollowUser,
        loadFollowers,
        loadFollowing,
        followers,
        following,
        forgotSenha,
        resetSenha,
        checkIfUserFollow,
        isTermAccepted,
        setIsTermAccepted,
        updateUserTerm
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
